import { render, staticRenderFns } from "./part1.vue?vue&type=template&id=735e9cee&scoped=true"
import script from "./part1.vue?vue&type=script&lang=js"
export * from "./part1.vue?vue&type=script&lang=js"
import style0 from "./part1.vue?vue&type=style&index=0&id=735e9cee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735e9cee",
  null
  
)

export default component.exports